import React from 'react';
import PropTypes from 'prop-types';
import FuseTheme from "../global/theme";
import HelpIcon from 'material-ui/svg-icons/action/help';

const styles = {
    tooltip: {
        display: 'inline-block',
        position: 'absolute',
        width: 18,
        height: 18,
        margin: '-3px 0 0 5px',
    },
    tooltipIcon: {
        width: 18,
        height: 18,
        color: FuseTheme.palette.primary1Color,
    },
};

/**
 * A function that returns a tooltip icon.
 *
 * @param dataFor
 * @return {*}
 * @constructor
 */
const TooltipIcon = ({dataFor}) => (
    <span data-tip data-for={dataFor} style={styles.tooltip} className="tooltip-icon">
        <HelpIcon style={styles.tooltipIcon}/>
    </span>
);

TooltipIcon.propTypes = {
    dataFor: PropTypes.string,
};

export default TooltipIcon;


// WEBPACK FOOTER //
// ./src/Fuse/components/TooltipIcon.js